import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: '首页', href: '/' },
  { label: '分类', href: '/categories' },
  { label: '文章', href: '/articles' },
  { label: '关于我们', href: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [pathname]);

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled
            ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/50 shadow-sm'
            : 'bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex items-center justify-between h-16 md:h-18">
            <Link to="/" className="flex items-center gap-2 group">
              <div className="w-9 h-9 md:w-10 md:h-10 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-cloud-line text-xl text-background-50 w-5 h-5 flex items-center justify-center"></i>
              </div>
              <div className="flex flex-col">
                <span className="text-lg md:text-xl font-heading font-bold text-foreground-900 leading-tight tracking-wide">
                  开云
                </span>
                <span className="text-xs text-secondary-500 leading-tight tracking-wider">KAIYUN</span>
              </div>
            </Link>

            <nav className="hidden md:flex items-center gap-1" aria-label="主导航">
              {navLinks.map((link) => (
                <Link
                  key={link.href}
                  to={link.href}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                    pathname === link.href
                      ? 'text-primary-500 bg-primary-500/10'
                      : 'text-secondary-600 hover:text-foreground-900 hover:bg-background-200/50'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
            </nav>

            <div className="hidden md:flex items-center gap-3">
              <Link
                to="/"
                className="px-5 py-2 rounded-lg text-sm font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                立即注册
              </Link>
            </div>

            <button
              onClick={() => setMobileOpen(!mobileOpen)}
              className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-800 hover:bg-background-200/50 transition-colors cursor-pointer"
              aria-label="打开菜单"
            >
              <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>
      </header>

      {mobileOpen && (
        <div className="fixed inset-0 z-40 md:hidden">
          <div className="absolute inset-0 bg-background-50/95 backdrop-blur-sm" onClick={() => setMobileOpen(false)}></div>
          <div className="absolute top-16 left-0 right-0 bg-background-100 border-b border-background-200/50 shadow-lg">
            <nav className="px-4 py-4 flex flex-col gap-2" aria-label="移动端导航">
              {navLinks.map((link) => (
                <Link
                  key={link.href}
                  to={link.href}
                  className={`px-4 py-3 rounded-lg text-base font-medium transition-all duration-200 whitespace-nowrap ${
                    pathname === link.href
                      ? 'text-primary-500 bg-primary-500/10'
                      : 'text-secondary-600 hover:text-foreground-900 hover:bg-background-200/50'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
              <Link
                to="/"
                className="mt-2 px-5 py-3 rounded-lg text-base font-medium bg-primary-500 text-background-50 text-center hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                立即注册
              </Link>
            </nav>
          </div>
        </div>
      )}
    </>
  );
}